import script from "./AccountSettingsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountSettingsCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__